export default __webpack_public_path__ + "static/media/netflix-clone.f5eb322a.png";